riot.tag2('page-404', '<layout><div class="container vertical-space"><h2>The requested page was not found</h2><p><a href="?">Jump to the top page of ACSIN-14 & ICSPM26 web site.</a></p></div></layout>', '', '', function(opts) {
});



//////////////////
// WEBPACK FOOTER
// ./src/scripts/page-404.tag.slim
// module id = 32
// module chunks = 0